export default __webpack_public_path__ + "static/media/css.2f489abe.svg";